import styled from "styled-components"

export const ArivalContent = styled.div`
    & h3 {
        font-size: 2rem;
        color: #444;
    }
    & div {
        font-size: 2.2rem;
        color: #444;
        padding-bottom: 0.5rem;

        & span {
            font-size: 1.5rem;
            color: #666;
        }
    }
`